<template>
  <img
    class="detail-icon"
    src="../assets/img/DetailIcon.png"
    alt="Detail Icon"
    style="padding-top: 4px"
  />
</template>

<style>
.detail-icon {
  display: inline;
}
</style>
